import { useState } from 'react'
import styled from 'styled-components'

import ColorSelector from 'shared/components/ColorSelector'
import ThirdLevelTitle from 'shared/components/Tools/components/LeftPanel/components/ThirdLevelTitle'
import SecondLevelTitle from 'shared/components/Tools/components/PanelSecondLevelTitle'
import ChiliVariables from 'shared/components/Tools/services/ChiliVariables'
import CMYK from 'shared/entities/CMYK'
import { CMYKValues, ColorCMYK } from 'shared/types/global'
import CustomScrollbars from 'shared/ui/SimpleBar'

const variablesApi = ChiliVariables.getInstance()

const CurrentColor = styled.div`
  width: 90%;
  height: 57px;
  border-radius: 15px;
  margin-bottom: 16px;
`

type ChangeColorPanelProps = {
  titleId: string
  colorName: string
  variableName: string
  value: ColorCMYK
  onBackButtonClick: () => void
  onChange: (color: ColorCMYK) => void
}

const ChangeColorPanel: React.FC<ChangeColorPanelProps> = ({
  titleId,
  colorName,
  variableName,
  value,
  onBackButtonClick,
  onChange
}) => {
  const [color, setColor] = useState<ColorCMYK>(value)

  const handleColorChange = (field: CMYKValues, value: number) => {
    const newColor = { ...color, [field]: value }
    setColor(newColor)
    onChange(newColor)
  }

  return (
    <CustomScrollbars
      fixedHeaderMarginBottom={210}
      fixedHeader={
        <>
          <SecondLevelTitle
            titleId={titleId}
            props={{ name: colorName.toLowerCase() }}
            onClick={onBackButtonClick}
          />
          <CurrentColor
            style={{ background: new CMYK({ ...color }).toCSS() }}
          />
        </>
      }
    >
      <div>
        <ThirdLevelTitle titleId="Change.color.selector" />

        <ColorSelector value={color} onChange={handleColorChange} />
      </div>
    </CustomScrollbars>
  )
}

export default ChangeColorPanel
